import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-partner-legal-info',
  templateUrl: './partner-legal-info.component.html',
  styleUrl: './partner-legal-info.component.less'
})
export class PartnerLegalInfoComponent implements OnInit, AfterViewInit {

  @Input() sponsorOnboardingCMSData: any;
  @Input() legalDetalis: any;
  @Output() legalDataValueChange = new EventEmitter<any>();

  constructor(
    private el: ElementRef, 
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    
  }

  valueChange(event: any, key: string) {
    switch (key) {
      case 'enableTnC':
        this.legalDetalis.enableTnC = event;
        break;
      case 'enablePrivacy':
        this.legalDetalis.enablePrivacy = event;
    }

    this.legalDataValueChange.emit(this.legalDetalis);
  }

  ngAfterViewInit(): void {
    // Use a timeout to wait until the markdown content is rendered
    setTimeout(() => {
      // Select all anchor tags inside the markdown container
      const links = this.el.nativeElement.querySelectorAll('#tnc-content a');
      console.log('links',links);
      links.forEach((link: HTMLAnchorElement) => {
        // Set target="_blank" to make links open in a new tab
        this.renderer.setAttribute(link, 'target', '_blank');
        // Optionally set rel="noopener noreferrer" for security
        this.renderer.setAttribute(link, 'rel', 'noopener noreferrer');
      });

      // Trigger change detection
      this.cdr.detectChanges();
    }, 0); // Timeout set to 0 to push it to the end of the event loop
  }

}
